if (!customElements.get("product-variant-swatches")) {
  customElements.define(
    "product-variant-swatches",
    class ProductVariantSwatches extends window.Component {
      constructor() {
        super();
        this.MAX_COLOR_SHOW = 9;
        this.inited = false;
        this.showMore = false;
        this.fieldsets = this.querySelectorAll("fieldset");
        this.showMoreButton = this.querySelector(".show-more");
        this.initUpdateVariant();
        this.observerInit();
      }

      observerInit = () => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(async (entry) => {
              if (entry.isIntersecting) {
                if(this.inited) {
                  const currentSelectedOptions = this.getCurrentSelectedOption();
                  if (this.initSelection.Size != currentSelectedOptions.Size) {
                    this.showMore = false;
                    this.handleVariantItem("Size", this.initSelection.Size);
                  }
                  if (this.initSelection.Waist != currentSelectedOptions.Waist) {
                    this.showMore = false;
                    this.handleVariantItem("Waist", this.initSelection.Waist);
                  }

                  return;
                } 
                this.inited = true;
                // console.log("intersecting");
                this.showMore = false;
                const initSelectedOptions = this.getCurrentSelectedOption();
                this.initSelection = initSelectedOptions;
                this.handleEnableOrDisableOptionValue(initSelectedOptions);
                this.handleListenerShowMore();
              }
            });
          },
          {
            rootMargin: "60px",
          }
        );
        observer.observe(this);
      };

      initUpdateVariant() {
        this.fieldsets?.forEach((fieldset) => {
          fieldset.addEventListener("change", (event) => {
            if (event.target.tagName === "INPUT") {
              this.showMore = false;
              const { smallestSize } = this.handleVariantItem(event.target.name, event.target.value);
              if (smallestSize) {
                this.handleVariantItem("Size", smallestSize)
                document.querySelector('input[name="Size"]').click();
              }
            }
          });
        });
      }

      getItemData(variantItem) {
        return {
          value: variantItem.getAttribute("option-value"),
          option: variantItem.getAttribute("option-name"),
        };
      }

      checkDisableOptionValue = (optionName, optionValue, selectedOptions) => {
        const variants = this.getVariants();
        const newValue = {
          ...selectedOptions,
          [optionName]: optionValue,
        };
        const selectedVariant = this.getSelectedVariant(variants, newValue);
        return (
          selectedVariant?.available ||
          (selectedVariant?.inventoryQuantity ?? 0) > 0
        );
      };

      handleEnableOrDisableOptionValue = (selectedOptions) => {
        const allOptionsValueElement = this.querySelectorAll(".item-swatch");
        allOptionsValueElement.forEach((item) => {
          const { value, option } = this.getItemData(item);
          const isSelected = selectedOptions[option || ""] == value;
          if (isSelected) {
            item.setAttribute("checked", "true");
          } else {
            item.setAttribute("checked", "false");
          }
          const optionName = item.getAttribute("option-name");
          const optionValue = item.getAttribute("option-value");
          const isAvailable = this.checkDisableOptionValue(
            optionName,
            optionValue,
            selectedOptions
          );
          if (!isAvailable) {
            item.setAttribute("disabled", "true");
          } else {
            item.setAttribute("disabled", "false");
          }
        });
        this.handleShowButtonShowMore();
      };

      handleListenerShowMore = () => {
        this.showMoreButton.addEventListener("click", () => {
          const allOptionsValueElement = this.querySelectorAll(".item-swatch[option-name='Color'][disabled='false']");
          allOptionsValueElement.forEach((item, index) => {
            const isShow = item.getAttribute("disabled") !== "true";
            const optionName = item.getAttribute("option-name");
            if (optionName !== "Color") return;
            if (this.showMore) {
              item.style.display = isShow && index < this.MAX_COLOR_SHOW ? "flex" : "none"; 
            } else {
              item.style.display = isShow ? "flex" : "none";
            }
          });
          if (this.showMore) {
            this.showMore = false;
            this.showMoreButton.innerHTML = `+${allOptionsValueElement.length - this.MAX_COLOR_SHOW}`;
          } else {
            this.showMore = true;
            this.showMoreButton.innerHTML = `Hide`;
          }
        });
      };

      handleShowButtonShowMore = () => {
        const allOptionsValueElement = this.querySelectorAll(".item-swatch[option-name='Color'][disabled='false']");
        let count = allOptionsValueElement.length;       
        allOptionsValueElement.forEach((item, index) => {
          if (index < this.MAX_COLOR_SHOW) {
            item.style.display = "flex";
          } else {
            item.style.display = "none";
          }
        });
        if (!this.showMoreButton) return;
        if (count > this.MAX_COLOR_SHOW) {
          this.showMoreButton.style.display = "flex";
          this.showMoreButton.innerHTML = `+${count - this.MAX_COLOR_SHOW}`;
        } else {
          this.showMoreButton.style.display = "none";
        }
      };

      handleVariantItem = (optionName, optionValue) => {
        const { selectedVariant, selectedOptions } =
          this.getSelectedVariantByVariantItem(optionName, optionValue);
          let smallestSize = null;
        if (optionName === "Waist") {
          const variants = this.getVariants();
          const availableSizes = variants
            .filter((variant) => variant.options.some((opt) => opt.name === "Waist" && opt.value === optionValue))
            .filter((variant) => (variant.inventoryQuantity ?? 0) > 0)
            .map((variant) => variant.options.find((opt) => opt.name === "Size")?.value)
            .sort((a, b) => a - b);
      
          if (availableSizes.length > 0) {
            smallestSize = availableSizes[0];
          }
        }

        this.handleEnableOrDisableOptionValue(selectedOptions);
        if (!selectedVariant) return;
        this.setContext("variantSelected", selectedVariant);
        return {
          smallestSize: smallestSize
        }
      };

      getVariants = () => {
        const variants = this.getState("variants");
        const optionsWithValues = this.getState("optionsWithValues");
        const variantInventoryQuantity = this.getState(
          "variantInventoryQuantity"
        );
        return variants?.map((variant, index) => {
          let options = [];
          const keys = [1, 2, 3];
          keys.forEach((key) => {
            const option = variant[`option${key}`];
            if (option) {
              options.push({
                name: optionsWithValues.find((item) => item.position === key)
                  ?.name,
                value: option,
              });
            }
          });
          return {
            ...variant,
            options,
            inventoryQuantity: variantInventoryQuantity?.[index] || 0,
          };
        });
      };

      getSelectedVariantByVariantItem = (optionName, optionValue) => {
        const currentSelected = this.getCurrentSelectedOption();
        const newValue = {
          ...currentSelected,
          [optionName]: optionValue,
        };
        const variants = this.getVariants();
        const selectedVariant = this.getSelectedVariant(variants, newValue);
        return {
          selectedVariant,
          selectedOptions: newValue,
        };
      };

      getOptionsWithValues = () => {
        return this.getState("optionsWithValues");
      };

      getCurrentSelectedOption = () => {
        const variantSelected = this.getContext("variantSelected");
        const optionsWithValues = this.getOptionsWithValues();
        if (!optionsWithValues) return;
        let result = {};
        const keys = [1, 2, 3];
        keys.forEach((key) => {
          const value = variantSelected[`option${key}`];
          const item = optionsWithValues.find((item) => item.position === key);
          if (item?.name && value) {
            result = {
              ...result,
              [item.name]: value,
            };
          }
        });

        return result;
      };

      getSelectedVariant = (variants, choices, variantId) => {
        if (
          !variants ||
          !variants.length ||
          !choices ||
          variants[0]?.options?.length !== Object.keys(choices).length
        ) {
          return;
        }
        if (variantId) {
          const data = variants.find((variant) => variant.id == variantId);
          if (data) return data;
        }
        return variants.find((variant) => {
          return Object.entries(choices).every(([name, value]) => {
            return variant?.options?.some(
              (option) => option.name === name && option.value === value
            );
          });
        });
      };
    }
  );
}
